import $ from 'jquery';

/**
 * Main initialization, called after DOMContentLoaded.
 */
function init() {
  const zfz = window.zfz || {};

  zfz.initYoutube = function () {
    $.each($('.youtube-player'), function () {
      const yplayer = $(this);
      const ytid = yplayer.data('ytid');
      const iframe = `<iframe frameborder="0" src="https://www.youtube.com/embed/${ytid}?autoplay=1" allowfullscreen="allowfullscreen"></iframe>`;

      yplayer.on('click', function () {
        yplayer.html(iframe);
        $(this).off('click');
      });
    });
  };

  zfz.initYoutube();

  window.zfz = zfz;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
